import Vue from "vue";
import constant from "../constant";

const state = Vue.observable({
  isAuthenticated: false,
  user: null,
});

const parseJson = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("[authStatus] Unable to parse stored value:", error);
    return null;
  }
};

const readAuthState = () => {
  const tokenKey = constant.authToken || "token-app-storekeeper";
  const userKey = constant.authUser || "user-app-storekeeper";
  const token = localStorage.getItem(tokenKey);
  const userRaw = localStorage.getItem(userKey);
  const user = parseJson(userRaw);

  state.isAuthenticated = Boolean(token);
  state.user = state.isAuthenticated ? user : null;

  return { ...state };
};

export const authStatus = {
  get isAuthenticated() {
    readAuthState();
    return state.isAuthenticated;
  },
  get user() {
    readAuthState();
    return state.user;
  },
  refresh() {
    return readAuthState();
  },
};

const plugin = {
  install(VueInstance) {
    if (plugin.installed) {
      return;
    }
    plugin.installed = true;

    const syncState = () => authStatus.refresh();
    syncState();

    VueInstance.prototype.$authStatus = authStatus;

    VueInstance.mixin({
      computed: {
        $isAuthenticated() {
          return authStatus.isAuthenticated;
        },
        $authUser() {
          return authStatus.user;
        },
      },
    });

    window.addEventListener("storage", syncState);
  },
};

export default plugin;
